import { connectInstructions } from "../../util/redux";
import FacialRecognitionInstructionsComponent from "../../components/facial-recognition/instructions";

const FacialRecognitionInstructions = connectInstructions(
  FacialRecognitionInstructionsComponent
);

export default FacialRecognitionInstructions;
